import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from 'react';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { useLocation, useParams } from 'react-router-dom';
import { useFetch } from 'shared/api/hooks';
import { Content } from './context';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { select_billed_sim_card } from 'console/sim/utils/select-sim';
import { RouterDialog } from 'shared/components/dialogs/router';
export const SimMainDialog = memo(function SimMainDialog() {
    const [loading, response, error] = useFetch('get_sim_tariffs');
    const [loading_statuses, response_statuses, error_statuses] = useFetch('sim/info_for_user');
    const context = useMemo(() => ({
        sim_tariffs: {
            loading,
            error,
            descriptions: response?.sim_tariffs,
            sim_shipping_x100: response?.sim_shipping_x100,
        },
        sim_statuses: {
            loading: loading_statuses,
            error: error_statuses,
            statuses: response_statuses?.sim_statuses,
        },
    }), [loading, response, error, loading_statuses, response_statuses, error_statuses]);
    const { pathname } = useLocation();
    const { msisdn, sim_id, operator } = useParams();
    const billed_sim = useAppSelector((state) => select_billed_sim_card(state, sim_id == null || operator == null
        ? null
        : { id: sim_id, operator }));
    const getTitle = useCallback((pathname) => {
        if (pathname == '/sim/order') {
            return 'Выбор тарифа';
        }
        if (pathname.search('/sim/order/') != -1) {
            return 'Оформление доставки';
        }
        if (pathname == '/sim/add') {
            return 'Добавление сим-карты';
        }
        if (pathname.search('/sim/foreign/') != -1) {
            return `Cим-карта +${msisdn}`;
        }
        if (pathname.search('/pay') != -1) {
            return `Оплата +${billed_sim?.sim_card.msisdn}`;
        }
        if (pathname.search('/sim/billed/') != -1) {
            return `Cим-карта +${billed_sim?.sim_card.msisdn}`;
        }
        return 'Сим-карты';
    }, [msisdn, billed_sim]);
    const sx = useCallback((theme) => ({
        '& .MuiAppBar-root': {
            backgroundColor: pathname.search('/sim/order') != -1
                ? theme.palette.mode == 'dark'
                    ? 'transparent'
                    : theme.palette.primary.dark
                : undefined,
        },
    }), [pathname]);
    return (_jsx(ErrorBoundary, { children: _jsx(Content.Provider, { value: context, children: _jsx(RouterDialog, { title: getTitle(pathname), sx: sx }) }) }));
});
